import {createGlobalStyle} from "styled-components";

const HomeStyle = createGlobalStyle`
    .box-wrap{    
        overflow: auto;
        height: calc(100vh - 137px);
        -ms-overflow-style: none;
        scrollbar-width: none;
        display: grid;
        grid-template-columns: 31.3% 31.3% 31.3%;
        grid-gap: 32px 32px;
        ::-webkit-scrollbar {
          display: none;
        }
        .box-content{
            border-radius: 10px;
            .edit-button{
                border-radius: 24px;
                color: #282828;
                width: 100px;
                height: 30px;
                font-weight: bold;
                border: unset;
            }
            .information{
                display: -webkit-box;
                max-width: 100%;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-all;
            }
        }
        .box{
            border-radius: 10px;
            width: 100%;
            .box-header{
                border-radius: 10px 10px 0 0;
                height: 80px;
                width: calc(100% - 0px);
                .contact-us-img-wrap{
                    background: #BDFF00;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    display: flex;
                    justify-content: center;
                    img{
                        width: 16px;
                    }
                }
                img{
                    width: 30px;
                }
                .check-mark{
                    margin-left: 13px;
                    display: inline-block;
                }
                ul{
                    list-style-type: none;
                }
                .form-button-ghost{
                    color: #BDFF00;
                    box-sizing: border-box;
                    border-radius: 24px;
                    padding: 8px 16px;
                    margin-top: 15px;
                    font-weight: 700;
                    transition: all 0.25s linear 0s;
                    background: #282828;
                    border: 1px solid #BDFF00;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 18px;
                }
            }
            .box-footer{
                .label-para{
                    margin-left: 3px;
                    margin-bottom: 3px;
                }
                .checkbox{
                    background: #BDFF00;
                    border-radius: 24px;
                }
            }
        }
    }
    
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 28px;
        input { 
            opacity: 0;
            width: 0;
            height: 0;
        }
        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: #A0A0A0;
            -webkit-transition: .4s;
            transition: .4s;
            :before {
                position: absolute;
                content: "";
                height: 24px;
                width: 24px;
                left: 2.5px;
                bottom: 2px;
                background-color: white;
                -webkit-transition: .4s;
                transition: .4s;
                box-shadow:  0px 1px 7px 1px rgba(0, 0, 0, 0.25);
            }
        }
        input:checked + .slider {
            background-color:  #BDFF00;
        }
        input:focus + .slider {
            box-shadow:  0px 1px 7px 1px rgba(0, 0, 0, 0.25);
        }
        input:checked + .slider:before {
            -webkit-transform: translateX(29.8px);
            -ms-transform: translateX(29.8px);
            transform: translateX(31px);
        }
        .round {
            border-radius: 40px;
            :before {
                border-radius: 50%;
            }
        }
    }
    .module-table-wrap{
        .table-bordered > tbody > tr > td, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > td, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > thead > tr > th {
            border: 3px solid #000;
        }
        .table-bordered{
            tbody{
                tr{
                    td{
                        border: 3px solid  #0F171E;
                    }
                }
            }
        }
        .table-wrap{
            width: 100%;
            overflow: auto;
            height: calc(100vh - 140px);
            .table{
                border-collapse: unset;
                border: 1px solid #000;
                thead{
                    th{
                        padding-left: 10px;
                        padding-top: 18px;
                        padding-bottom: 18px;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        position: sticky;
                        top: -3px;
                        z-index: 8;
                        border: unset!important;
                    }
                }
                tbody{
                    td{
                        padding: 14px 10px;
                        border: unset!important;
                        white-space: nowrap;
                    }
                    td:nth-child(2){
                        width: 380px;
                    }
                }
            }
        }
    }
`;

export default HomeStyle;